import { useState } from 'react';
import { Checkbox, Grid, MenuItem } from '@mui/material';
import { handleChangeModuleData } from '../../helpers/handleChangeModuleData';
import { TableInput } from '../../../../components/common';
import DatePickerMui from '../../../../components/common/DatePickerMui';
import moment from 'moment';

import {
  AddIconButton,
  DeleteIconButton,
  RemoveIconButton,
} from '../../../../components/common/button/CustomIconButton';
import formatDate from '../../../../components/common/formatDate';
import AutocompleteMuiCustom from '../../../../components/common/AutocompleteMuiCustom';
import CustomSelect from '../../../../components/common/SelectField';
import { convToTime } from '../../../../utils/helpers';
import { TimePicker } from '@mui/x-date-pickers';

interface IProps {
  moduleData: any;
  isView: boolean;
  handelDeleteRows: any;
  machineData: any;
  toolsData: any;
  gaugesData: any;
  fixturesData: any;
}

const TBody = ({
  moduleData,
  isView,
  handelDeleteRows,
  machineData,
  toolsData,
  gaugesData,
  fixturesData,
}: IProps) => {
  const [render, setRender] = useState(false);

  return (
    <>
      <tbody>
        {moduleData &&
          moduleData.processes.map((process: any, index: number) => (
            <tr key={index + 'module data'}>
              <td style={{ minWidth: '150px' }}>
                {isView && process.select_no}
                {!isView && (
                  <CustomSelect
                    name="dropdown"
                    value={process.select_no || ''}
                    onChange={(e) => {
                      process.select_no = e.target.value;
                      setRender((prev) => !prev);
                    }}
                    sx={{
                      textAlign: 'center',
                    }}
                  >
                    <MenuItem value="">NONE</MenuItem>
                    <MenuItem value="Machine No.">Machine No.</MenuItem>
                    <MenuItem value="Tool No.">Tool No.</MenuItem>
                    <MenuItem value="Fixture No.">Fixture No.</MenuItem>
                    <MenuItem value="Gauge No.">Gauge No.</MenuItem>
                  </CustomSelect>
                )}
              </td>
              {process.select_no === '' && <td style={{ width: '350px' }}></td>}
              {process.select_no === 'Machine No.' && (
                <td>
                  {isView && process?.machine_id?.machine_no}
                  {!isView && (
                    <AutocompleteMuiCustom
                      id="Machine No."
                      label="Machine"
                      option_name="machine_no"
                      key={'machine'}
                      arrayofObj={machineData}
                      value={process?.machine_id || ''}
                      onChange={(e, value) => {
                        process.machine_id = value;
                        setRender((prev) => !prev);
                      }}
                      sx={{ width: '350px' }}
                    />
                  )}
                </td>
              )}
              {process.select_no === 'Tool No.' && (
                <td>
                  {isView &&
                    process?.tool_id?.tool_name +
                      ' ' +
                      process?.tool_id?.part_id?.part_name}
                  {!isView && (
                    <AutocompleteMuiCustom
                      id="Tools"
                      label="Tool No."
                      option_name="tool_name"
                      option_name_2="part_id"
                      key={'tools'}
                      arrayofObj={toolsData}
                      value={process?.tool_id || ''}
                      onChange={(e, value) => {
                        process.tool_id = value;
                        setRender((prev) => !prev);
                      }}
                      sx={{ width: '350px' }}
                    />
                  )}
                </td>
              )}
              {process.select_no === 'Gauge No.' && (
                <td>
                  {isView && process?.gauge_id?.number}
                  {!isView && (
                    <AutocompleteMuiCustom
                      id="Gauge"
                      label="Gauge No."
                      option_name="number"
                      key={'gauges'}
                      arrayofObj={gaugesData}
                      value={process?.gauge_id || ''}
                      onChange={(e, value) => {
                        process.gauge_id = value;
                        setRender((prev) => !prev);
                      }}
                      sx={{ width: '350px' }}
                    />
                  )}
                </td>
              )}
              {process.select_no === 'Fixture No.' && (
                <td>
                  {isView && process?.fixture_id?.number}
                  {!isView && (
                    <AutocompleteMuiCustom
                      id="Fixture"
                      label="Fixture No."
                      option_name="number"
                      key={'fixtures'}
                      arrayofObj={fixturesData}
                      value={process?.fixture_id || ''}
                      onChange={(e, value) => {
                        process.fixture_id = value;
                        setRender((prev) => !prev);
                      }}
                      sx={{ width: '350px' }}
                    />
                  )}
                </td>
              )}
              <td style={{ minWidth: '300px' }}>
                <TableInput
                  isView={isView}
                  name="breakdown_details"
                  type="text"
                  value={process.breakdown_details}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process?.bd_time)
                ) : (
                  <TimePicker
                    value={moment(process?.bd_time || '')}
                    onChange={(date) => {
                      process.bd_time = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="attended_by"
                  type="text"
                  value={process.attended_by}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '200px' }}>
                {isView ? (
                  formatDate(process.attended_date)
                ) : (
                  <DatePickerMui
                    value={moment(process.attended_date || null)}
                    onChange={(date) => {
                      process.attended_date = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process?.attended_time)
                ) : (
                  <TimePicker
                    value={moment(process?.attended_time || '')}
                    onChange={(date) => {
                      process.attended_time = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '200px' }}>
                {isView ? (
                  formatDate(process.work_completion_date)
                ) : (
                  <DatePickerMui
                    value={moment(process.work_completion_date || null)}
                    onChange={(date) => {
                      process.work_completion_date = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                {isView ? (
                  convToTime(process?.work_completion_time)
                ) : (
                  <TimePicker
                    value={moment(process?.work_completion_time || '')}
                    onChange={(date) => {
                      process.work_completion_time = date;
                      setRender((prev) => !prev);
                    }}
                  />
                )}
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="work_completion_status"
                  type="text"
                  value={process.work_completion_status}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              <td style={{ minWidth: '150px' }}>
                <TableInput
                  isView={isView}
                  name="work_completion_verified_by"
                  type="text"
                  value={process.work_completion_verified_by}
                  onChange={(e) => {
                    handleChangeModuleData(e, process);
                    setRender((prev) => !prev);
                  }}
                />
              </td>
              {!isView && (
                <td style={{ minWidth: '100px' }}>
                  <DeleteIconButton
                    tooltipTitle={'delete'}
                    onClick={() => handelDeleteRows(index)}
                  />
                </td>
              )}
            </tr>
          ))}
      </tbody>
    </>
  );
};

export default TBody;
